import { LinkType } from 'types'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Button from 'content-components/_Primatives/Button'
import style from './style.scss'

export type Props = {
  headlineText: string
  links: LinkType[]
}

function SimpleCTA({ headlineText, links }: Props) {
  return (
    <div className={style.wrapper}>
      <HeadlineTwo className={style.headlineText}>{headlineText}</HeadlineTwo>
      <div className={style.buttons}>
        {links.map((link) => (
          <Button
            key={link.text}
            className={style.button}
            url={link.url}
            variant='secondaryBlack'
          >
            {link.text}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default SimpleCTA
